<template>
  <a
    :class="{'is-loading-2':isExporting}"
    class="button export-btn"
    data-track="Export reviews link"
    href="#"
    @click.prevent="exportReviews"
  >
    EXPORT REVIEWS</a>
</template>

<script>
/* global flash */
import axios from 'axios'

export default {
  name: 'ExportReviews',
  props: {
    bizSlug: {
      type: String,
      required: true
    },
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    },
    rating: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isExporting: false
    }
  },
  methods: {
    exportReviews () {
      if (!this.isExporting) {
        this.isExporting = true

        axios.get(`/analytics/${this.bizSlug}/reviews/export?
            startDate=${this.startDate}&
            endDate=${this.endDate}&
            track_activity_action=reviews.list.view&
            track_activity_event=ReviewListActivity&
            starRating[]=${this.rating}`)
          .then(data => {
            if (data.status === 204) {
              flash('You have 0 Reviews to export', 'is-warning')
            } else {
              data = data.data
              console.log(data)
              const link = document.createElement('a')
              link.download = data.data.fileName
              link.href = data.data.url
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            }
            this.isExporting = false
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/utilities/_colors.scss";

.export-btn {
  padding: 8px 17px;
  width: 130px;
  border-radius: 17.5px !important;
  border: 1px solid color('blue');
  color: color('blue');
  font-size: 12px;
  font-weight: 600;
}

.export-btn[disabled] {
  cursor: not-allowed;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ExportReviews.vue